import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import _ from "lodash";

import Socket from "socket";
import Alert from "shared/components/alert";
import CardButton from "../components/Button";
import DatePicker from "../components/DatePicker";
import CollapseText from "../components/CollapseText";
import {
  set_user_challenges,
  set_challenge_details,
  set_challenge_entries
} from "redux/challenges/action";
import { setIsLoading } from "redux/loader/action";
import cardImage from "assets/images/challenges/card-home.jpg";
import entryIcon from "assets/images/challenges/entry-icon.png";
import timePicker from "assets/images/challenges/time-picker.png";
import useWindowDimensions from "shared/helpers/getWindowDimensions";

const Challenge = (props) => {
  const dispatch = useDispatch();
  const { height } = useWindowDimensions();
  const {
    challengesReducer: {
      user_challenges,
      challenge_details,
      challenge_entries
    },
    gameReducer: { currentUser, mobile_app },
    paramsReducer
  } = useSelector((state) => state);

  const view_params = _.get(
    paramsReducer,
    "paramsObj.mobile_website.challenges.view"
  );
  const days_left = _.get(view_params, "days_left", "Days Left");
  const entries = _.get(view_params, "entries", "My Entries");
  const leaderboard = _.get(view_params, "leaderboard", "Team Leaderboard");
  const submit_label = _.get(view_params, "submit_label", "Submit Entry");
  const hint = _.get(view_params, "hint", "Enter Number");
  const submit = _.get(view_params, "submit", "Submit");
  const disabled = _.get(view_params, "disabled", "Note: Disabled by Admin");
  const [entryCount, setEntryCount] = useState("");
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const handleSetIsLoading = (value) => {
    dispatch(setIsLoading(value));
  };

  useEffect(() => {
    return Socket.addListener(
      "challenge-entry",
      handle_challenge_entry,
      challenge_entry_error
    );
  }, []);

  const handle_challenge_entry = (res) => {
    if (res && res.challenge_data) {
      setSelectedDate(new Date());
      setEntryCount("");
      handleSetIsLoading(false);
      Alert(200, "Entry submitted successfully");
    }
  };
  const challenge_entry_error = () => {
    handleSetIsLoading(false);
  };

  useEffect(() => {
    const pathArr = props.location.pathname.split("/");
    const id = pathArr[pathArr.length - 1];
    const selected_challenge = user_challenges.find(
      (challenge) => challenge.challenge_id === id
    );
    dispatch(set_challenge_details(selected_challenge));
  }, [props.location, user_challenges]);

  useEffect(() => {
    return Socket.addListener(
      "challenge-get",
      handle_challenge_get,
      challenge_get_error
    );
  }, [challenge_details]);

  const handle_challenge_get = (res) => {
    if (res && res.challenge_data && _.isEmpty(challenge_entries)) {
      handleSetIsLoading(false);
      if (!_.isEmpty(res.challenge_data)) {
        dispatch(set_challenge_entries(res.challenge_data.data));
      }
      props.history.push({
        pathname: `/challenge/${challenge_details.challenge_id}/my_entries`
      });
    }

    if (res && res.user_challenges) {
      let filtered_challenges = res.user_challenges
        .filter(
          (item) =>
            !item.archived &&
            moment(item.start_date) < moment() &&
            moment(item.end_date).isSameOrAfter(moment().format("MM/DD/YYYY"))
        )
        .sort((a, b) => moment(a.end_date) - moment(b.end_date));
      dispatch(set_user_challenges(filtered_challenges));
      handleSetIsLoading(false);
      props.history.push({
        pathname: `/challenge/${challenge_details.challenge_id}/team_leaderboard`
      });
    }
  };
  const challenge_get_error = () => {
    handleSetIsLoading(false);
  };

  const handleMyEntriesClick = () => {
    if (_.isEmpty(challenge_entries)) {
      handleSetIsLoading(true);
      const data = {
        action: "challenge-get",
        table: ["Data"],
        challenge_id: challenge_details.challenge_id,
        user_id: currentUser.userId
        // user_id: "1"
      };
      Socket.sendMessage(data);
    } else {
      props.history.push({
        pathname: `/challenge/${challenge_details.challenge_id}/my_entries`
      });
    }
  };

  const handleLeaderboardClick = () => {
    if (challenge_details.show_data !== "None") {
      handleSetIsLoading(true);
      const data = {
        action: "challenge-get",
        table: ["userChallenges"],
        team_code: currentUser.team_code,
        user_id: currentUser.userId
        // team_code: "teamCode",
        // user_id: "1"
      };
      Socket.sendMessage(data);
    }
  };

  const daysLeft = () => {
    let eventdate = moment(challenge_details.end_date, "MM/DD/YYYY").add(
      1,
      "days"
    );
    let todaysdate = moment();
    return eventdate.diff(todaysdate, "days");
  };

  const handleEntryTs = () => {
    let date = moment(selectedDate).format("M/D/YYYY");
    let time = moment().format("hh:mm:ss");
    return moment(date + " " + time).unix();
  };

  const handleEntrySubmit = () => {
    if (!_.isEmpty(entryCount)) {
      handleSetIsLoading(true);
      const data = {
        action: "challenge-entry",
        challenge_id: challenge_details.challenge_id,
        entry: parseInt(entryCount),
        entry_action: "Add",
        entry_ts: handleEntryTs(),
        team_code: currentUser.team_code,
        user_id: currentUser.userId
        // team_code: "teamCode",
        // user_id: "1"
      };
      Socket.sendMessage(data);
    } else {
      Alert(400, "Entry must not be empty");
    }
  };

  const toggleDatePicker = () => {
    setDatePickerOpen((prev) => !prev);
  };

  const handleSelectDate = (date) => {
    setSelectedDate(date);
  };

  const handleOkClick = () => {
    toggleDatePicker();
  };

  return (
    <div className="challenges-wrapper">
      <div className="specific-challenge">
        {!_.isEmpty(challenge_details) && (
          <div className="home-card">
            <img
              alt=""
              src={
                challenge_details.challenge_image !== null
                  ? challenge_details.challenge_image
                  : cardImage
              }
              className="card-top-image specific"
            />
            <div
              className="card-content"
              style={{
                maxHeight: `${mobile_app ? height - 122 : height - 182}px`
              }}
            >
              <span className="challenge-time-left">{`${daysLeft()} ${
                daysLeft() === 1 ? "Day Left" : days_left
              }`}</span>
              <h2 className="challenge-name">{challenge_details.name}</h2>
              <CollapseText
                params={view_params}
                description={challenge_details.description}
                challenge_id={challenge_details.challenge_id}
              />
              <div className="button-container">
                <div className="my-entries" onClick={handleMyEntriesClick}>
                  <span className="enabled-text">{`📝 ${entries}`}</span>
                </div>
                <div
                  onClick={handleLeaderboardClick}
                  className={`my-entries ${
                    challenge_details.show_data === "None" ? "disabled" : ""
                  }`}
                >
                  <span className="enabled-text">{`🏆 ${leaderboard}`}</span>
                  {challenge_details.show_data === "None" && (
                    <span className="disabled-text">{disabled}</span>
                  )}
                </div>
              </div>
              <div className="date-picker-div">
                <h2 className="entry-label">{submit_label}</h2>
                <div className="date-div" onClick={() => toggleDatePicker()}>
                  <h2 className="entry-label">
                    {moment(selectedDate).format("M/D/YYYY")}
                  </h2>
                  <img alt="" src={timePicker} className="date-icon" />
                </div>
              </div>
              <input
                type="number"
                value={entryCount}
                onChange={(e) => setEntryCount(e.target.value)}
                className="entry-value"
                placeholder={`${hint} (${challenge_details.unit})`}
              />
              <CardButton text={submit} onPress={handleEntrySubmit} />
            </div>
          </div>
        )}
      </div>
      {datePickerOpen && (
        <DatePicker
          onOkClick={handleOkClick}
          onClose={toggleDatePicker}
          details={challenge_details}
          selectedDate={selectedDate}
          onSelectDate={handleSelectDate}
        />
      )}
    </div>
  );
};

export default Challenge;
